import { useContext } from "react";
import { ComponentProjectListPageContext, PageNewState } from ".";

export const usePageState = () => {
  const { pageState, setPageState } = useContext(
    ComponentProjectListPageContext,
  );
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
